import React, { ReactElement } from "react";
import { ArrowDownIcon, ArrowUpDownIcon, ArrowUpIcon } from "@chakra-ui/icons";
import { TSortableIconProps } from "./sortable-icon.config";

const SortableIcon = <T,>({
  column,
  sort,
}: TSortableIconProps<T>): ReactElement => {
  if (!column.sortable) {
    return <></>;
  }
  const sortField = column.sortKey ?? column.key;
  if (sort.fieldName === sortField && sort.direction === "ASC") {
    return <ArrowUpIcon />;
  }
  if (sort.fieldName === sortField && sort.direction === "DESC") {
    return <ArrowDownIcon />;
  }
  return <ArrowUpDownIcon />;
};

export default SortableIcon;
